
import { Input } from "@/components/ui/input";
import { useState, useEffect } from "react";
import { Search } from "lucide-react";

interface BookSearchProps {
  value?: string;
  onChange?: (value: string) => void;
  onSearch?: (query: string) => void;
  placeholder?: string;
}

export function BookSearch({ 
  value, 
  onChange, 
  onSearch, 
  placeholder = "Search books..." 
}: BookSearchProps) {
  const [searchQuery, setSearchQuery] = useState(value || "");
  
  // Handle direct input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchQuery(newValue);
    
    // Call appropriate handler
    if (onChange) onChange(newValue);
    if (onSearch) onSearch(newValue);
  };
  
  // Update internal state when value prop changes
  useEffect(() => {
    if (value !== undefined && value !== searchQuery) {
      setSearchQuery(value);
    }
  }, [value]);

  return (
    <div className="mb-4 relative w-full md:max-w-md">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 dark:text-slate-500" />
        <Input
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleChange}
          className="pl-10 w-full h-10 text-base"
        />
      </div>
    </div>
  );
}
